import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/content";

export const FaqAccordion = ({ limit }) => {
  const faqs = limit ? FAQS.slice(0, limit) : FAQS;
  return (
    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
      {faqs.map((f, i) => (
        <AccordionItem key={f.q} value={`faq-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
          <AccordionTrigger
            data-testid={`faq-trigger-${i}`}
            className="text-left text-[#F5F5F7] hover:text-[#00E5FF] text-base md:text-lg font-medium py-6 transition-colors duration-300"
          >
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-[#A1A1A6] leading-relaxed text-sm md:text-base pb-6">
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
